import React, { useState, useEffect } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import Swal from 'sweetalert2';
import {
  PageContainer,
  Header,
  AddButton,
  FiltersContainer,
  SearchInput,
  FilterSelect,
  TableContainer,
  Table,
  NoResults,
  StatusBadge,
  ActionButtons,
  ActionButton,
  ToggleSwitch,
  AgentInfo,
  AgentAvatar,
  AgentDetails,
  PaginationContainer,
  PageButton,
  EditModal,
  DeleteModal,
  PermModal,
  NewAgentModal,
  CreateUserModal,
  Toast,
  AgentFormWrapper,
} from './styles'; // Import your styled components

const AgentForm = ({ values, imobiliarias, idiomas, onChange, onFileChange, disableImobiliaria }) => (
  <AgentFormWrapper>
    <div className="avatar-area">
      <div className="avatar-circle">
        {values.previewImagem
          ? <img src={values.previewImagem} alt="Preview" />
          : <span>{(values.nomeAGENTE || '').trim().split(' ').map(n => n[0]).join('').slice(0,2).toUpperCase() || 'A'}</span>}
      </div>
      <label className="camera-button" aria-label="Selecionar foto">
        <input type="file" accept="image/*" onChange={e => onFileChange(e.target.files?.[0] || null)} />
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3l2-3h8l2 3h3a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
      </label>
      {values.previewImagem && (
        <button 
          type="button" 
          className="remove-image-button" 
          onClick={() => onFileChange(null)}
          aria-label="Remover imagem"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      )}
    </div>
    <div className="fields">
      <label>Nome<input type="text" value={values.nomeAGENTE || ''} onChange={e => onChange('nomeAGENTE', e.target.value)} /></label>
      <label>Email<input type="email" value={values.emailAGENTE || ''} onChange={e => onChange('emailAGENTE', e.target.value)} /></label>
      <label>Telefone<input type="text" value={values.telefoneAGENTE || ''} onChange={e => onChange('telefoneAGENTE', e.target.value)} /></label>
      <label>Telefone Móvel<input type="text" value={values.celularAGENTE || ''} onChange={e => onChange('celularAGENTE', e.target.value)} /></label>
      <label>Descrição<input type="text" value={values.descricaoAGENTE || ''} onChange={e => onChange('descricaoAGENTE', e.target.value)} /></label>
      {/* Categoria enviada vazia pelo backend, campo oculto */}
      <input type="hidden" value={values.categoriaAGENTE || ''} readOnly />
      <label>Idioma
        <select
          value={values.idiomaAGENTE || ''}
          onChange={e => onChange('idiomaAGENTE', e.target.value)}
        >
          <option value="">Selecione um idioma</option>
          {(idiomas || []).map(id => (
            <option key={id.codigo} value={id.codigo}>{id.nome || id.sigla || id.codigo}</option>
          ))}
        </select>
      </label>
      {imobiliarias && imobiliarias.length > 0 && (
        <label>Imobiliária
          <select
            value={values.codigoIMOBILIARIA === '' || values.codigoIMOBILIARIA === null || typeof values.codigoIMOBILIARIA === 'undefined' ? '' : String(values.codigoIMOBILIARIA)}
            onChange={e => onChange('codigoIMOBILIARIA', e.target.value === '' ? '' : parseInt(e.target.value, 10))}
            disabled={disableImobiliaria}
          >
            <option value="">Selecione uma imobiliária</option>
            {imobiliarias.map(imobiliaria => (
              <option key={imobiliaria.codigoIMOBILIARIA} value={imobiliaria.codigoIMOBILIARIA}>
                {imobiliaria.nomeIMOBILIARIA}
              </option>
            ))}
          </select>
        </label>
      )}
      <label className="switch-field">
        <span>Ativo</span>
        <ToggleSwitch>
          <input type="checkbox" checked={!!values.ativoAGENTE} onChange={e => onChange('ativoAGENTE', e.target.checked)} />
          <span className="slider" />
        </ToggleSwitch>
      </label>
    </div>
  </AgentFormWrapper>
);

const Agents = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [roleFilter, setRoleFilter] = useState('all');
  const [deleteModal, setDeleteModal] = useState(null);
  const [toast, setToast] = useState(null);

  const [agents, setAgents] = useState([]);

  // Normaliza o agente vindo da API para o formato da UI
  const mapApiAgent = (a) => ({
    id: a.codigoAGENTE,
    name: a.nomeAGENTE,
    role: a.descricaoAGENTE,
    status: (a.ativoAGENTE === true || a.ativoAGENTE === 1 || a.ativoAGENTE === '1') ? 'active' : 'inactive',
    avatar: (a.nomeAGENTE?.split(' ').map(n => n[0]).join('')).substring(0, 2).toUpperCase(),
    color: '#34574A',
    properties: 0,
    sales: 0,
    rating: 0,
    phone: a.telefoneAGENTE,
    email: a.emailAGENTE,
    whatsapp: a.celularAGENTE || '',
    categoriaAGENTE: a.categoriaAGENTE,
    idiomaAGENTE: a.idiomaAGENTE,
    codigoIMOBILIARIA: a.imobiliariaAGENTE,
    photoUrl: a.imagemAGENTE || a.fotoAGENTE || a.foto || a.imagem || ''
  });
  // Busca agentes da API (opcionalmente por imobiliária)
  async function fetchAgents(imobiliariaId) {
    const token = localStorage.getItem('auth_token');
    try {
      const url = `${import.meta.env.VITE_URL_API}/agentes/me`;
      const res = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'accept': 'application/json'
        }
      });
      let data = [];
      if (res.ok) {
        const body = await res.json();
        data = Array.isArray(body) ? body : (Array.isArray(body?.dados) ? body.dados : []);
      }
      // mantém todos os agentes (sem filtrar por imobiliária para não ocultar registros)
      const rawList = Array.isArray(data) ? data : [];
      // mapeia para o formato da UI
      const apiAgents = rawList.map(mapApiAgent);
      setAgents(apiAgents);
    } catch (e) {
      setToast({ type: 'error', message: 'Erro ao buscar agentes!' });
      setTimeout(() => setToast(null), 2500);
    }
  } 

  React.useEffect(() => {
    fetchAgents();
    // eslint-disable-next-line
  }, []);

  const [editModal, setEditModal] = useState(null); // agente a editar
  const [permModal, setPermModal] = useState(null); // agente para permissões
  const [editData, setEditData] = useState({
    removeImage: false,
  });
  const [newModal, setNewModal] = useState(false);
  const [newAgent, setNewAgent] = useState({
    nomeAGENTE: '',
    telefoneAGENTE: '',
    emailAGENTE: '',
    descricaoAGENTE: '',
    celularAGENTE: '',
    idiomaAGENTE: '',
    ativoAGENTE: true,
    codigoIMOBILIARIA: '',
    imagemAGENTE: null,
    previewImagem: null,
  });
  const resetNewAgent = () => setNewAgent({
    nomeAGENTE: '',
    telefoneAGENTE: '',
    emailAGENTE: '',
    descricaoAGENTE: '',
    celularAGENTE: '',
    idiomaAGENTE: '',
    ativoAGENTE: true,
    codigoIMOBILIARIA: '',
    imagemAGENTE: null,
    previewImagem: null,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const AGENTS_PER_PAGE = 6;
  const pageCount = Math.ceil(agents.length / AGENTS_PER_PAGE);
  const paginatedAgents = agents.slice((currentPage-1)*AGENTS_PER_PAGE, currentPage*AGENTS_PER_PAGE);
  const [createUserModal, setCreateUserModal] = useState(false);
  const [newUser, setNewUser] = useState({
    nomeAGENTE: '',
    telefoneAGENTE: '',
    emailAGENTE: '',
    descricaoAGENTE: '',
    celularAGENTE: '',
    categoriaAGENTE: '',
    idiomaAGENTE: '',
    ativoAGENTE: true,
    // exige escolha explícita
    codigoIMOBILIARIA: '',
    imagemAGENTE: null,
  });
  const [imobiliarias, setImobiliarias] = useState([]);
  const [idiomas, setIdiomas] = useState([]);
  const [selectedImobiliariaId, setSelectedImobiliariaId] = useState(() => {
    try { return parseInt(localStorage.getItem('selected_imobiliaria') || '0', 10) || 0; } catch { return 0; }
  });
  const [isSaving, setIsSaving] = useState(false);
  const [isSavingNewAgent, setIsSavingNewAgent] = useState(false);
  const [isSavingEdit, setIsSavingEdit] = useState(false);
  // util: pega a primeira imobiliária como default
  const getDefaultImobiliariaId = () => (imobiliarias && imobiliarias.length > 0 ? imobiliarias[0].codigoIMOBILIARIA : 0);

  useEffect(() => {
    // Fetch imobiliarias from the API
    async function fetchImobiliarias() {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/imobiliarias/me`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        const data = await response.json();
        setImobiliarias(data);
      } catch (error) {
        console.error('Failed to fetch imobiliarias:', error);
        setToast({ type: 'error', message: 'Erro ao carregar imobiliárias' });
        setTimeout(() => setToast(null), 3000);
      }
    }

    // usa a versão única/top-level
    fetchImobiliarias().then(() => {
      let stored = 0;
      try { stored = parseInt(localStorage.getItem('selected_imobiliaria') || '0', 10) || 0; } catch {}
      const defaultId = getDefaultImobiliariaId();
      const id = stored || defaultId;
      if (id) setSelectedImobiliariaId(id);
      fetchAgents(id);
    });
  }, []);

  // sempre que a imobiliária selecionada mudar, recarrega a lista
  useEffect(() => {
    if (selectedImobiliariaId) {
      fetchAgents(selectedImobiliariaId);
    }
  }, [selectedImobiliariaId]);

  // Carrega idiomas uma vez
  useEffect(() => {
    async function fetchIdiomas() {
      try {
        const token = localStorage.getItem('auth_token');
        const res = await fetch(`${import.meta.env.VITE_URL_API}/idiomas`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        const list = Array.isArray(data) ? data : (Array.isArray(data?.Registros) ? data.Registros : (Array.isArray(data?.registros) ? data.registros : []));
        const normalized = list
          .filter(i => i && (i.codigoIDIOMA || i.id || i.codigo || i.nomeIDIOMA || i.nome))
          .map(i => ({
            codigo: String(i.codigoIDIOMA ?? i.id ?? i.codigo ?? '').trim(),
            nome: i.nomeIDIOMA ?? i.nome ?? i.descricao ?? '',
            sigla: i.siglaIDIOMA ?? i.siglaIdioma ?? i.siglaidioma ?? i.sigla ?? ''
          }));
        setIdiomas(normalized);
      } catch (e) {
        console.error('Erro ao carregar idiomas', e);
      }
    }
    fetchIdiomas();
  }, []);

  async function handleStatusToggle(agentId) {
    const token = localStorage.getItem('auth_token');
    const agent = agents.find(a => a.id === agentId);
    if (!agent) return;
    const novoStatus = agent.status === 'active' ? false : true;
    try {
      const res = await fetch(`${import.meta.env.VITE_URL_API}/agentes/${agentId}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify({
          ativoAGENTE: novoStatus === true // força booleano
        })
      });
      if (res.ok) {
        setToast({ type: 'success', message: `Status do agente atualizado com sucesso` });
        fetchAgents();
      } else if (res.status === 404) {
        setToast({ type: 'error', message: `Agente não encontrado na API (ID: ${agentId}, Nome: ${agent.name}). Recarregando lista.` });
        fetchAgents();
      } else {
        let msg = 'Erro ao atualizar status!';
        try {
          const err = await res.json();
          if (err && err.message) msg += ' ' + err.message;
        } catch {}
        setToast({ type: 'error', message: msg });
      }
    } catch (e) {
      setToast({ type: 'error', message: 'Erro ao atualizar status! ' + (e?.message || '') });
    }
    setTimeout(() => setToast(null), 3000);

  }

  function handleDelete(agentId) {
    setDeleteModal(agentId);
  }
 
  async function confirmDelete() {
    const token = localStorage.getItem('auth_token');
    try {
      const res = await fetch(`${import.meta.env.VITE_URL_API}/agentes/${deleteModal}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'accept': '*/*'
        }
      });
      if (res.status === 204) {
        setToast({ type: 'success', message: `Agente removido com sucesso` });
        setDeleteModal(null);
        fetchAgents(selectedImobiliariaId || getDefaultImobiliariaId());
      } else {
        setToast({ type: 'error', message: 'Erro ao remover agente!' });
      }
    } catch (e) {
      setToast({ type: 'error', message: 'Erro ao remover agente!' });
    }
    setTimeout(() => setToast(null), 3000);
 
  }

  function handleEdit(agent) {
    setEditData({
      id: agent.id,
      nomeAGENTE: agent.name || '',
      telefoneAGENTE: agent.phone || '',
      emailAGENTE: agent.email || '',
      descricaoAGENTE: agent.role || '',
      celularAGENTE: agent.whatsapp || '',
      categoriaAGENTE: agent.categoriaAGENTE || '',
      idiomaAGENTE: agent.idiomaAGENTE || '',
      ativoAGENTE: agent.status === 'active',
      codigoIMOBILIARIA: selectedImobiliariaId || getDefaultImobiliariaId(),
      imagemAGENTE: agent.imagemAGENTE || agent.fotoAGENTE || agent.foto || agent.imagem || null,
      previewImagem: agent.photoUrl || null,
      removeImage: false,
    });
    setEditModal(agent.id);
  }
  async function saveEdit() {
    if (isSavingEdit) return;
    if (!editData.nomeAGENTE || !editData.telefoneAGENTE || !editData.emailAGENTE || !editData.descricaoAGENTE || !editData.celularAGENTE || !editData.idiomaAGENTE || !editData.codigoIMOBILIARIA) {
      setToast({ type: 'error', message: 'Preencha todos os campos obrigatórios!' });
      setTimeout(() => setToast(null), 2500);
      return;
    }
    const token = localStorage.getItem('auth_token');
    setIsSavingEdit(true);
    try {
      const form = new FormData();
      if (editData.imagemAGENTE) form.append('imagemAGENTE', editData.imagemAGENTE);
      if (editData.removeImage) form.append('removeImage', 'true');
      form.append('nomeAGENTE', editData.nomeAGENTE || '');
      form.append('telefoneAGENTE', editData.telefoneAGENTE || '');
      form.append('emailAGENTE', editData.emailAGENTE || '');
      form.append('descricaoAGENTE', editData.descricaoAGENTE || '');
      form.append('celularAGENTE', editData.celularAGENTE || '');
      form.append('categoriaAGENTE', '');
      form.append('idiomaAGENTE', editData.idiomaAGENTE || '');
      form.append('ativoAGENTE', String(editData.ativoAGENTE));
      form.append('imobiliariaAGENTE', String(parseInt(editData.codigoIMOBILIARIA, 10)));

      const res = await fetch(`${import.meta.env.VITE_URL_API}/agentes/${editData.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: form
      });
      if (!res.ok) {
        throw new Error('Erro ao atualizar Agente');
      }
      await fetchAgents(selectedImobiliariaId || getDefaultImobiliariaId());
      setToast({ type: 'success', message: 'Agente atualizado com sucesso!' });
      setEditModal(null);
    } catch (error) {
      console.error(error);
      setToast({ type: 'error', message: 'Erro ao atualizar Agente' });
    } finally {
      setIsSavingEdit(false);
      setTimeout(() => setToast(null), 2500);
    }
  }

  function handlePerm(agent) {
    setPermModal(agent.id);
  }
  function savePerm() {
    setToast({ type: 'success', message: `Permissões salvas com sucesso` });
    setPermModal(null);
    setTimeout(() => setToast(null), 3000);
  }

  function handleNewAgent() {
    const id = selectedImobiliariaId || getDefaultImobiliariaId();
    if (!id) {
      setToast({ type: 'error', message: 'Nenhuma imobiliária disponível. Cadastre/seleciona uma primeiro.' });
      setTimeout(() => setToast(null), 2500);
      return;
    }
    resetNewAgent();
    setNewModal(true);
  }
  async function saveNewAgent() {
    if (isSavingNewAgent) return;
    if (!newAgent.nomeAGENTE || !newAgent.telefoneAGENTE || !newAgent.emailAGENTE || !newAgent.descricaoAGENTE || !newAgent.celularAGENTE || !newAgent.idiomaAGENTE) {
      setToast({ type: 'error', message: 'Preencha todos os campos obrigatórios!' });
      setTimeout(() => setToast(null), 2500);
      return;
    }
    const imobId = newAgent.codigoIMOBILIARIA;
    if (!imobId || Number.isNaN(Number(imobId))) {
      setToast({ type: 'error', message: 'Selecione uma imobiliária válida antes de salvar.' });
      setTimeout(() => setToast(null), 2500);
      return;
    }
    const token = localStorage.getItem('auth_token');
    setIsSavingNewAgent(true);
    try {
      const form = new FormData();
      if (newAgent.imagemAGENTE) form.append('imagemAGENTE', newAgent.imagemAGENTE);
      form.append('nomeAGENTE', newAgent.nomeAGENTE || '');
      form.append('telefoneAGENTE', newAgent.telefoneAGENTE || '');
      form.append('emailAGENTE', newAgent.emailAGENTE || '');
      form.append('descricaoAGENTE', newAgent.descricaoAGENTE || '');
      form.append('celularAGENTE', newAgent.celularAGENTE || '');
      form.append('categoriaAGENTE', '');
      form.append('idiomaAGENTE', newAgent.idiomaAGENTE || '');
      form.append('ativoAGENTE', String(newAgent.ativoAGENTE));
      form.append('imobiliariaAGENTE', String(imobId));

      const res = await fetch(`${import.meta.env.VITE_URL_API}/agentes`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: form
      });
      if (res.ok) {
        // refetch direto da API para consistência
        fetchAgents(selectedImobiliariaId || getDefaultImobiliariaId());
        setNewModal(false);
        resetNewAgent();
        await Swal.fire({
          title: 'Sucesso',
          text: 'Agente criado com sucesso!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
      } else {
        setToast({ type: 'error', message: 'Erro ao criar agente!' });
        await Swal.fire({
          title: 'Erro',
          text: 'Não foi possível criar o agente.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } catch (e) {
      setToast({ type: 'error', message: 'Erro ao criar agente!' });
      await Swal.fire({
        title: 'Erro',
        text: 'Não foi possível criar o agente.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setIsSavingNewAgent(false);
    }
    setTimeout(() => setToast(null), 2500);
  }

  function handleCreateUser() {
    const id = selectedImobiliariaId || getDefaultImobiliariaId();
    if (!id) {
      setToast({ type: 'error', message: 'Nenhuma imobiliária disponível. Cadastre/seleciona uma primeiro.' });
      setTimeout(() => setToast(null), 2500);
      return;
    }
    setCreateUserModal(true);
    setNewUser({
      nomeAGENTE: '',
      telefoneAGENTE: '',
      emailAGENTE: '',
      descricaoAGENTE: '',
      celularAGENTE: '',
      categoriaAGENTE: '',
      idiomaAGENTE: '',
      ativoAGENTE: true,
      // exige escolha explícita
      codigoIMOBILIARIA: '',
      imagemAGENTE: null,
    });
  }

  function saveNewUser() {
    if (isSaving) return;
    if (!newUser.nomeAGENTE || !newUser.telefoneAGENTE || !newUser.emailAGENTE || !newUser.codigoIMOBILIARIA) {
      setToast({ type: 'error', message: 'Preencha todos os campos obrigatórios!' });
      setTimeout(() => setToast(null), 2500);
      return;
    }
    if (!newUser.codigoIMOBILIARIA || Number.isNaN(Number(newUser.codigoIMOBILIARIA))) {
      setToast({ type: 'error', message: 'Selecione uma imobiliária válida!' });
      setTimeout(() => setToast(null), 2500);
      return;
    }

    setIsSaving(true);
    const form = new FormData();
    if (newUser.imagemAGENTE) form.append('imagemAGENTE', newUser.imagemAGENTE);
    form.append('nomeAGENTE', newUser.nomeAGENTE || '');
    form.append('telefoneAGENTE', newUser.telefoneAGENTE || '');
    form.append('emailAGENTE', newUser.emailAGENTE || '');
    form.append('descricaoAGENTE', newUser.descricaoAGENTE || '');
    form.append('celularAGENTE', newUser.celularAGENTE || '');
    form.append('categoriaAGENTE', newUser.categoriaAGENTE || '');
    form.append('idiomaAGENTE', newUser.idiomaAGENTE || '');
    form.append('ativoAGENTE', String(newUser.ativoAGENTE));
    form.append('imobiliariaAGENTE', String(parseInt(newUser.codigoIMOBILIARIA, 10)));

    fetch(`${import.meta.env.VITE_URL_API}/agentes`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      },
      body: form,
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao criar Agente');
        }
        return response.json();
      })
      .then(data => {
        // Atualiza a lista imediatamente com o retorno, além do refetch
        try {
          const created = mapApiAgent(data || {});
          if (created && created.id) {
            setAgents(prev => {
              const exists = prev.some(a => a.id === created.id);
              return exists ? prev : [created, ...prev];
            });
          }
        } catch (_) {}
        // Atualiza a lista a partir da API para consistência
        fetchAgents(selectedImobiliariaId || getDefaultImobiliariaId());
        setToast({ type: 'success', message: 'Agente criado com sucesso!' });
        setCreateUserModal(false);
        Swal.fire({
          title: 'Sucesso',
          text: 'Agente criado com sucesso!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        // já fez refetch acima
      })
      .catch(error => {
        console.error(error);
        setToast({ type: 'error', message: 'Erro ao criar Agente' });
        Swal.fire({
          title: 'Erro',
          text: 'Não foi possível criar o Agente.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      })
      .finally(() => {
        setNewUser({
          nomeAGENTE: '',
          telefoneAGENTE: '',
          emailAGENTE: '',
          descricaoAGENTE: '',
          celularAGENTE: '',
          categoriaAGENTE: '',
          idiomaAGENTE: '',
          ativoAGENTE: true,
          codigoIMOBILIARIA: '',
          imagemAGENTE: null,
          previewImagem: null,
        });
        setIsSaving(false);
      });
  }

  function goToPage(page) {
    setCurrentPage(page);
  }

  const filteredAgents = agents.filter(agent => {
    const matchesSearch = agent.name.toLowerCase().includes(searchTerm.toLowerCase()) || agent.role.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || agent.status === statusFilter;
    const matchesRole = roleFilter === 'all' || agent.role === roleFilter;
    return matchesSearch && matchesStatus && matchesRole;
  });

  return (
    <PageContainer>
      <Header>
        <h1>Agentes</h1>
        <AddButton onClick={handleCreateUser}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 5v14M5 12h14"/></svg>
          Criar Agente
        </AddButton>
      </Header>
      <FiltersContainer>
        <SearchInput type="text" placeholder="Buscar por nome..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
        <FilterSelect value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
          <option value="all">Todo Status</option>
          <option value="active">Ativos</option>
          <option value="inactive">Inativos</option>
        </FilterSelect>
        <FilterSelect value={roleFilter} onChange={e => setRoleFilter(e.target.value)}>
          <option value="all">Todas as Funções</option>
          <option value="Corretor Senior">Corretor Senior</option>
          <option value="Gerente de Vendas">Gerente de Vendas</option>
          <option value="Corretor">Corretor</option>
          <option value="Assistente">Assistente</option>
        </FilterSelect>
      </FiltersContainer>
      {filteredAgents.length > 0 ? (
        <TableContainer>
          <Table>
            <thead>
              <tr>
                <th>Agente</th><th>Imóveis</th><th>Vendas</th><th>Avaliação</th><th>Status</th><th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredAgents.slice((currentPage-1)*AGENTS_PER_PAGE, currentPage*AGENTS_PER_PAGE).map(agent => (
                <tr key={agent.id}>
                  <td><AgentInfo><AgentAvatar color={agent.color} $photoUrl={agent.photoUrl}>{agent.avatar}</AgentAvatar><AgentDetails><div className="name">{agent.name}</div><div className="role">{agent.role}</div></AgentDetails></AgentInfo></td>
                  <td>{agent.properties}</td>
                  <td>{agent.sales}</td>
                  <td>{agent.rating}</td>
                  <td><StatusBadge className={agent.status}>{agent.status === 'active' ? 'Ativo' : 'Inativo'}</StatusBadge></td>
                  <td>
                    <ActionButtons>
                      <ToggleSwitch>
                        <input type="checkbox" checked={agent.status === 'active'} onChange={() => handleStatusToggle(agent.id)} />
                        <span className="slider" />
                      </ToggleSwitch>
                      <ActionButton onClick={() => handleEdit(agent)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      </ActionButton>
                      <ActionButton $variant="primary" onClick={() => handlePerm(agent)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5"/></svg>
                      </ActionButton>
                      <ActionButton $variant="danger" onClick={() => handleDelete(agent.id)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6"/></svg>
                      </ActionButton>
                    </ActionButtons>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableContainer>
      ) : (
        <NoResults>
          <h3>Nenhum agente encontrado</h3>
          <p>Tente ajustar seus filtros para encontrar mais resultados</p>
          <AddButton onClick={handleNewAgent}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 5v14M5 12h14"/></svg>
            Novo Agente
          </AddButton>
        </NoResults>
      )}
      {/* Paginação */}
      {pageCount > 1 && (
        <PaginationContainer>
          <PageButton onClick={() => goToPage(currentPage-1)} disabled={currentPage === 1}>Anterior</PageButton>
          {Array.from({length: pageCount}, (_, i) => (
            <PageButton
              key={i+1}
              $active={currentPage === i+1}
              onClick={() => goToPage(i+1)}
            >{i+1}</PageButton>
          ))}
          <PageButton onClick={() => goToPage(currentPage+1)} disabled={currentPage === pageCount}>Próxima</PageButton>
        </PaginationContainer>
      )}
      {/* Modal de edição premium */}
      {editModal && (
        <EditModal>
          <div className="modal-content">
            <button className="close-btn" onClick={() => setEditModal(null)}>×</button>
            <FaUserCircle className="edit-avatar" />
            <h3>Editar Agente</h3>
            <AgentForm
              values={editData}
              imobiliarias={imobiliarias}
              idiomas={idiomas}
              onChange={(field, value) => setEditData(prev => ({ ...prev, [field]: value }))}
              onFileChange={file => setEditData(prev => ({ 
                ...prev, 
                imagemAGENTE: file, 
                previewImagem: file ? URL.createObjectURL(file) : null,
                removeImage: file === null && prev.previewImagem !== null
              }))}
            />
            <div className="edit-actions">
              <AddButton onClick={saveEdit} disabled={isSavingEdit}>{isSavingEdit ? 'Salvando...' : 'Salvar'}</AddButton>
              <ActionButton $variant="danger" onClick={() => setEditModal(null)}>Cancelar</ActionButton>
            </div>
          </div>
        </EditModal>
      )}
      {/* Modal de exclusão compacto e elegante */}
      {deleteModal && (
        <DeleteModal>
          <div className="modal-content">
            <h3>Excluir agente</h3>
            <p>Tem certeza que deseja excluir este agente?</p>
            <div className="delete-actions">
              <button className="btn-cancel" onClick={() => setDeleteModal(null)}>Cancelar</button>
              <button className="btn-delete" onClick={confirmDelete}>Excluir</button>
            </div>
          </div>
        </DeleteModal>
      )}
      {/* Modal de permissões premium */}
      {permModal && (
        <PermModal>
          <div className="modal-content">
            <button className="close-btn" onClick={() => setPermModal(null)}>×</button>
            <h3>Permissões do Agente</h3>
            <div className="perm-list">
              <label className="perm-item"><input type="checkbox" defaultChecked /> Gerenciar imóveis</label>
              <label className="perm-item"><input type="checkbox" /> Ver relatórios</label>
              <label className="perm-item"><input type="checkbox" /> Editar agência</label>
            </div>
            <div className="perm-actions">
              <AddButton onClick={savePerm}>Salvar</AddButton>
              <ActionButton $variant="danger" onClick={() => setPermModal(null)}>Cancelar</ActionButton>
            </div>
          </div>
        </PermModal>
      )}
      {/* Modal de novo agente */}
      {newModal && (
        <NewAgentModal>
          <div className="modal-content">
            <button className="close-btn" onClick={() => setNewModal(false)}>×</button>
            <FaUserCircle className="edit-avatar" />
            <h3>Novo Agente</h3>
            <AgentForm
              values={newAgent}
              imobiliarias={imobiliarias}
              idiomas={idiomas}
              onChange={(field, value) => setNewAgent(prev => ({ ...prev, [field]: value }))}
              onFileChange={file => setNewAgent(prev => ({ ...prev, imagemAGENTE: file, previewImagem: file ? URL.createObjectURL(file) : null }))}
              disableImobiliaria={false}
            />
            <div className="new-actions">
              <button className="btn-secondary" onClick={() => setNewModal(false)}>Cancelar</button>
              <button className="btn-primary" onClick={saveNewAgent} disabled={isSavingNewAgent}>
                {isSavingNewAgent ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </NewAgentModal>
      )}
      {/* Modal de criação de Agente */}
      {createUserModal && (
        <CreateUserModal>
          <div className="modal-content">
            <div className="modal-header">
              <h3>Criar Novo Agente</h3>
              <button className="close-btn" onClick={() => setCreateUserModal(false)}>×</button>
            </div>
            <AgentForm
              values={newUser}
              imobiliarias={imobiliarias}
              idiomas={idiomas}
              onChange={(field, value) => setNewUser(prev => ({ ...prev, [field]: value }))}
              onFileChange={file => setNewUser(prev => ({ ...prev, imagemAGENTE: file, previewImagem: file ? URL.createObjectURL(file) : null }))}
            />
            <div className="actions">
              <button className="btn-cancel" onClick={() => setCreateUserModal(false)}>Cancelar</button>
              <button className="btn-save" onClick={saveNewUser} disabled={isSaving}>
                {isSaving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </CreateUserModal>
      )}
      {/* Toast de feedback */}
      {toast && (
        <Toast className={toast.type}>{toast.message}</Toast>
      )}
    </PageContainer>
  );
};

export default Agents;